module.exports = __webpack_public_path__ + "img/premium-tka.1d881e10.svg";